import ApiClient from './ApiClient';

class ResourceMonitorAPI extends ApiClient {
  constructor() {
    super('resource_monitor', { accountScoped: true });
  }

  speedTest(phase) {
    return axios.get(this.url, { params: { speed_phase: phase } });
  }
}

export default new ResourceMonitorAPI();
